import Input from '@/components/basicComponents/input';
import Select from '@/components/basicComponents/select';
import { buildTestId } from '@/lib/utils/testIds';
import { COUNTRY_CALLING_CODES_MAP } from '@trace-8/trace8-schema';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { IRenderTemplateField } from '../../types';

interface CustomComponentProps {
  control: any;
  field: IRenderTemplateField;
  pageName?: string;
  ignoreRequired: boolean;
}

export const PhoneNumber = ({ control, field, pageName = '', ignoreRequired }: CustomComponentProps) => {
  return (
    <PhoneFields>
      <Controller
        name={`${pageName}.${field.name}.${field?.validation?.mapping?.['countryCode'] ?? 'countryCode'}`}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Select
            label={field?.config?.labels['countryCode'] ?? 'Country Code'}
            value={value || ''}
            setValue={onChange}
            options={Object.entries(COUNTRY_CALLING_CODES_MAP).map(([key, value]) => ({ label: value, value: key }))}
            errorText={error?.message}
            isRequiredField={!!field?.validation?.required && !ignoreRequired}
            size="md"
            width="200px"
            withSearch
            data-testid={field.name ? buildTestId('signature-packet', pageName, field.name, 'countryCode') : undefined}
            data-testid-dropdown={field.name ? buildTestId('signature-packet', pageName, field.name, 'countryCode', 'dropdown') : undefined}
            data-testid-option={field.name ? buildTestId('signature-packet', pageName, field.name, 'countryCode', 'option') : undefined}
          />
        )}
      />
      <Controller
        name={`${pageName}.${field.name}.${field?.validation?.mapping?.['number'] ?? 'number'}`}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Input
            label={field?.config?.labels['number'] ?? 'Phone'}
            value={value || ''}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            errorText={error?.message}
            isRequiredField={!!field?.validation?.required && !ignoreRequired}
            size="md"
            data-testid={field.name ? buildTestId('signature-packet', pageName, field.name, 'number') : undefined}
          />
        )}
      />
    </PhoneFields>
  );
};

const PhoneFields = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;
